// extracted by mini-css-extract-plugin
export default {"timeStamp":"style--timeStamp--14b143"};